import { Stack, SxProps, Theme, Typography } from '@mui/material';
import {
  SearchFieldSearchIconGraphic,
  searchFieldTriggerRowSx,
} from 'Components/SearchFieldIcon';
import { RefObject, ReactNode } from 'react';

interface ISearchFieldTriggerProps {
  label: ReactNode;
  onActivate: () => void;
  endSlot?: ReactNode;
  height?: string | number;
  borderRadius?: string | number;
  triggerRef?: RefObject<HTMLButtonElement | null>;
  typographySx?: SxProps<Theme>;
  sx?: SxProps<Theme>;
}

export const SearchFieldTrigger = ({
  label,
  onActivate,
  endSlot,
  height = '44px',
  borderRadius = '22px',
  triggerRef,
  typographySx,
  sx,
}: ISearchFieldTriggerProps) => (
  <Stack
    ref={triggerRef}
    component='button'
    type='button'
    onClick={onActivate}
    direction='row'
    alignItems='center'
    sx={{
      width: '100%',
      height,
      flexDirection: 'row',
      alignItems: 'center',
      background: '#fff',
      border: '1px solid',
      borderColor: 'primary.shade_200',
      borderRadius,
      cursor: 'pointer',
      ...searchFieldTriggerRowSx,
      '&:focus-visible': {
        outline: '2px solid',
        outlineColor: 'primary.main',
        outlineOffset: '2px',
      },
      ...sx,
    }}
  >
    <SearchFieldSearchIconGraphic />
    <Typography
      component='span'
      variant='body3'
      sx={{
        flex: 1,
        minWidth: 0,
        textAlign: 'right',
        ...typographySx,
      }}
    >
      {label}
    </Typography>
    {endSlot}
  </Stack>
);
